import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAdvisoryBoard, getAdvisoryBoards, resetState } from "../features/AdvisoryBoard/AdvisoryBoardSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Post",
    dataIndex: "post",
  },
  {
    title: "About",
    dataIndex: "about",
  },
  {
    title: "Image",
    dataIndex: "image",
    render: logo => <img src={logo} alt="Board Logo" style={{ width: 50, height: 50 }} />,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Associationlist = () => {
  const [open, setOpen] = useState(false);
  const [AssociationId, setAssociationId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setAssociationId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getAdvisoryBoards());
  }, []);
  const getAssociationState = useSelector((state) => state.advisoryBoard.AdvisoryBoards);
  

  
  const data1 = [];
  console.log(getAssociationState.length);
  for (let i = 0; i < getAssociationState.length; i++) {
    data1.push({
      key: i + 1,
      name: getAssociationState[i].name, 
      post: getAssociationState[i].post,
      about: getAssociationState[i].about, 
      image: getAssociationState[i].images,

      action: (
        <>
          <Link
            to={`/admin/Add-Advisory-Board/${getAssociationState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getAssociationState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAdvisoryBoard(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getAdvisoryBoards());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Member List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(AssociationId);
        }}
        title="Are you sure you want to delete this Member?"
      />
    </div>
  );
};

export default Associationlist;
